import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { permissionLevels } from '../utils/enums';

interface ProtectedRouteProps {
    children: ReactNode;
    requiredLevel: keyof typeof permissionLevels;
    redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredLevel, redirectTo = '/' }) => {
    const { user } = useAuth();

    if (user && user.profileId.permsLevel <= permissionLevels[requiredLevel]) {
        return <>{children}</>;
    } else {
        return <Navigate to={redirectTo} replace />;
    }
};

export default ProtectedRoute;
